import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,[_c(VCardTitle,{staticStyle:{"font-weight":"700","color":"#004d40","background-color":"#eee","display":"-webkit-box","-webkit-line-clamp":"2","/* change as needed */\n-webkit-box-orient":"vertical","overflow":"hidden","word-break":"keep-all"}},[_vm._t("cardTitle")],2),_c(VCardSubtitle,{staticStyle:{"color":"#000","background-color":"#eee"}},[_vm._t("cardSubtitle")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }